export default {
  title: {
    en: 'How do you want to send your gift',
  },
  hint: {
    en: 'Please allow 5-10 days for a card delivery by mail.',
  },
  byMail: {
    en: 'Send card by mail',
  },
  byEmail: {
    en: 'Send gift by email',
  },
  buttonTitle: {
    en: 'Choose',
  },
}
